<template>
  <div>
    <div class="headerTop">
      <div class="EC_width display_between height_100">
        <div>
          <a href="https://gp519.com/"
             class="headerTop_home"><img src="/image/english/homeicon.png"
                 class="marginRight5" />全科主站</a>
        </div>
        <div class="display_center_ud">
          <!-- <div class="headerTop_search">
                        <img src="/image/geren/search.png" />
                        <input type="text" name="" id="" value="" />
                    </div> -->
          <!-- <div class="headerTop_login">
                        <img src="/image/geren/indexren.png" />
                        Login
                    </div> -->
        </div>
      </div>
    </div>
    <div class="header EC_width">
      <div class="logoWrap display_center_ud">
        <img src="../../assets/img/logo_en.png"
             class="logo_en" />
      </div>
      <div class="menuList display_flex">
        <div :class="{ menu_item_active: activeindex == 0 }"
             class="menu_item">
          <router-link to="enhome">HOME</router-link>
        </div>
        <div :class="{ menu_item_active: activeindex == 1 }"
             class="menu_item">
          <a href="javascript:void(0)"
             @click="$router.push({ name: 'enAllNews', query: { urltitle: 'NEWS' } })">
            NEWS
          </a>
        </div>
        <div :class="{ menu_item_active: activeindex == 2 }"
             class="menu_item">
          <a href="javascript:void(0)"
             @click="$router.push({ name: 'enAllNews', query: { urltitle: 'Journal' } })">
            JOURNAL
          </a>
        </div>
        <div :class="{ menu_item_active: activeindex == 3 }"
             class="menu_item">
          <a href="javascript:void(0)"
             @click="$router.push({ name: 'enAllNews', query: { urltitle: 'EditorialBoard' } })">
            EDITORIAL BOARD
          </a>
        </div>
        <div :class="{ menu_item_active: activeindex == 4 }"
             class="menu_item">
          <a href="javascript:void(0)"
             @click="$router.push({ name: 'enAllNews', query: { urltitle: 'DisciplineDevelopment' } })">
            DISCIPLINE DEVELOPMENT
          </a>
        </div>
        <div :class="{ menu_item_active: activeindex == 5 }"
             class="menu_item">
          <a href="javascript:void(0)"
             @click="$router.push({ name: 'enAllNews', query: { urltitle: 'TrainingConference' } })">
            TRAINING CONFERENCE
          </a>
        </div>
        <div :class="{ menu_item_active: activeindex == 6 }"
             class="menu_item">
          <a href="javascript:void(0)"
             @click="$router.push({ name: 'enAllNews', query: { urltitle: 'CONTACT' } })">
            CONTACT
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'en_header',
  data () {
    return {
      activeindex: 0
    };
  },
  mounted () {
    if (this.$route.query.urltitle != undefined) {
      this.routeactivt();
    } else if (this.$route.meta.activeNum != undefined) {
      this.activeindex = this.$route.meta.activeNum;
    }
  },
  methods: {
    MenuClick (index) {
      this.activeindex = index;
    },
    routeactivt () {
      switch (this.$route.query.urltitle.replace(/\s+/g, '').toLowerCase()) {
        case 'news':
          this.activeindex = 1;
          break;
        case 'journal':
          this.activeindex = 2;
          break;
        case 'editorialboard':
          this.activeindex = 3;
          break;
        case 'disciplinedevelopment':
          this.activeindex = 4;
          break;
        case 'trainingconference':
          this.activeindex = 5;
          break;
        case 'contact':
          this.activeindex = 6;
          break;
      }
    }
  },
  watch: {
    $route (to) {
      if (this.$route.query.urltitle != undefined) {
        this.routeactivt();
      } else if (to.meta.activeNum != undefined) {
        this.activeindex = to.meta.activeNum;
      }
    }
  }
  // beforeRouteEnter(to, from, next) {
  //     // 在渲染该组件的对应路由被 confirm 前调用
  //     // 不！能！获取组件实例 `this`
  //     // 因为当守卫执行前，组件实例还没被创建
  //     next(vm => {
  //         if (this.$route.query.urltitle != undefined) {
  //             this.routeactivt();
  //         } else if (to.meta.activeNum != undefined) {
  //             vm.activeindex = to.meta.activeNum;
  //         }
  //     });
  // },
  // beforeRouteUpdate(to, from, next) {
  //     if (to.meta.activeNum != undefined) {
  //         this.activeindex = to.meta.activeNum;
  //     }
  //     next();
  // }
};
</script>

<style scoped>
/* 页面的顶部搜索条 */
.headerTop {
    height: 34px;
    background: #0b485d;
    min-width: 1240px;
}

.headerTop_home {
    color: #fff;
    font-size: 14px;
}

.headerTop_search {
    position: relative;
}

.headerTop_search input {
    width: 200px;
    height: 26px;
    outline: none;
    border-radius: 26px;
    box-sizing: border-box;
    padding-left: 20px;
}

.headerTop_search img {
    position: absolute;
    right: 18px;
    top: 4px;
    cursor: pointer;
}

.headerTop_login {
    color: #fff;
}

.headerTop_login img {
    margin-left: 20px;
    margin-right: 6px;
}

/* 头部样式 */
.header {
    height: 90px;
    display: flex;
    min-width: 1240px;
}

.logoWrap {
    width: 310px;
}
.logo_en {
    height: 82px;
}

.menuList {
    flex: 1;
}

.menu_item {
    padding: 0 8px;
    line-height: 90px;
    box-sizing: border-box;
}

.menu_item a {
    color: #333;
    font-weight: bold;
}

.menu_item_active {
    border-bottom: 3px solid #0b8686;
}

.menu_item_active a {
    color: #a6c9c8;
}
</style>
